<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >

    <template v-slot:activator="{ on }">
      <v-btn
          icon
          flat
          v-on="on"
      >
        <v-icon small medium>mdi-delete</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        Remover Tipo de Documento
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout justify-center>
            <v-flex xs12>
              Deseja remover a Tipologia '{{ typology.name }}'?
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-space-between>
          <v-btn
              :disabled="loading"
              flat
              @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="red darken-2"
              flat
              :loading="loading"
              @click="destroy()"
          >
            Remover
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import TypologyService from '@/services/applications/configurations/TypologyService';

  export default {
    name: 'Delete',
    props: ['typology'],
    data() {
      return {
        loading: false,
        dialog: false,
      };
    },
    methods: {
      destroy() {
        TypologyService
          .destroy(this.typology.id)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Tipologia removido com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.dialog = false;
          })
          .catch(({ response }) => {
            this.dialog = false;
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
